import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {WorkoutsDependencies} from '../dependencies';
import type {ExerciseId} from '../domain/exercise-id.value-object';
import {keys} from './keys';

export type GetCatalogExerciseQueryDependencies = Pick<WorkoutsDependencies, 'controllers'>;

export const getCatalogExerciseQuery = (
  {controllers}: GetCatalogExerciseQueryDependencies,
  exerciseId: ExerciseId,
) =>
  queryOptions({
    queryKey: keys.catalogExercises.detail(exerciseId),
    queryFn: () => controllers.workoutController.getCatalogExercise(exerciseId).then(unwrap),
  });
